import React, { useState } from "react";
import { NblocksButton } from "./NblocksButton";
import { SkeletonLoader } from "./SkeletonLoader";
import { GetTenantDocument, GetTenantPaymentDetailsDocument, SetTenantPlanDetailsDocument } from "../../gql/graphql";
import { classNameFilter } from "../../utils/ComponentHelpers";
import { useMutation, useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { PricingCard } from "./PricingCard";
const PricingCards = ({
  plans,
  loadingCardsData,
  cardPlaceholderCount,
  className,
  currency,
  recurrenceInterval,
  planSelectHandler
}) => {
  cardPlaceholderCount = cardPlaceholderCount ? cardPlaceholderCount : 3;
  const {
    t
  } = useTranslation();
  const {
    data: paymentDetailsQuery,
    loading: paymentDetailsLoading
  } = useQuery(GetTenantPaymentDetailsDocument);
  const [loadingButtonIndex, setLoadingButtonIndex] = useState();

  // Updating Tenant instance
  const [setTenantPaymentDetailsMutation, SetTenantPaymentDetailsData] = useMutation(SetTenantPlanDetailsDocument);
  const setPlanDetails = async (planKey, price, index) => {
    setLoadingButtonIndex(index);
    const result = await setTenantPaymentDetailsMutation({
      variables: {
        details: {
          planKey,
          priceOffer: {
            currency: price.currency,
            recurrenceInterval: price.recurrenceInterval
          }
        }
      },
      refetchQueries: [GetTenantDocument, GetTenantPaymentDetailsDocument]
    });
    if (result.data?.setTenantPlanDetails) {
      planSelectHandler(result.data.setTenantPlanDetails.status);
    }
  };

  /**
   * Price should be displayed on this page since currency and recurrenceInterval matches
   * @param price
   * @returns
   */
  const isPriceValid = price => {
    return price.currency === currency && price.recurrenceInterval === recurrenceInterval;
  };
  const isPriceSelected = (planKey, price) => {
    const selectedPlan = paymentDetailsQuery?.getTenantPaymentDetails.details.plan;
    const selectedPrice = paymentDetailsQuery?.getTenantPaymentDetails.details.price;
    if (selectedPlan && selectedPrice) {
      return selectedPlan.key === planKey && selectedPrice.currency === price.currency && selectedPrice.recurrenceInterval === price.recurrenceInterval;
    }
    return false;
  };
  const filteredPlans = plans ? plans.filter(plan => plan.prices.some(price => isPriceValid(price))) : [];
  const isLoading = loadingCardsData || paymentDetailsLoading;
  return /*#__PURE__*/React.createElement("div", {
    className: classNameFilter(className, "flex gap-4 justify-center")
  }, isLoading && [...Array(cardPlaceholderCount).keys()].map((_, i) => {
    return /*#__PURE__*/React.createElement(SkeletonLoading, {
      i: i,
      key: `skeleton-loading-${i}`
    });
  }), !isLoading && filteredPlans.map(({
    name,
    description,
    key,
    prices,
    trial,
    trialDays
  }, index) => {
    const price = prices.find(price => isPriceValid(price));
    if (price) {
      return /*#__PURE__*/React.createElement(PricingCard, {
        key: index,
        name: name,
        description: description ? description : "",
        trial: trial,
        trialDays: trialDays,
        price: price,
        didSelect: () => setPlanDetails(key, price, index),
        selected: isPriceSelected(key, price),
        loading: index === loadingButtonIndex
      });
    }
  }));
};
const SkeletonLoading = ({
  i
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: "min-h-8 border min-w-8 p-8 rounded-xl",
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/React.createElement(SkeletonLoader, {
    className: "w-full h-7 rounded-xl"
  }), /*#__PURE__*/React.createElement(SkeletonLoader, {
    className: "w-14 h-12 mr-1 rounded-xl inline-block"
  }), /*#__PURE__*/React.createElement(SkeletonLoader, {
    className: "w-8 h-8 rounded-xl inline-block"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/React.createElement(NblocksButton, {
    type: "primary",
    size: "md",
    fullWidth: true,
    disabled: true
  }, t("Get Started"))));
};
export { PricingCards };